import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Checkmark = props => (
  <SvgIcon width="118" height="117" viewBox="0 0 118 117" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M33.4976 59.4702L50.6012 76.5L84.4976 42.75" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
);

export default Checkmark;
